<template>
  <div>
    <b-row class="px-4 py-3 align-items-center">
      <b-col cols="6" lg="6">
        <h3>งานเพิ่มเติม</h3>
      </b-col>
      <b-col cols="6" lg="6" class="text-right">
        <b-button variant="outline-success" class="p-2" @click="addWork()" v-if="!isDetails">
          <b-icon icon="plus" class="mb-1"></b-icon> เพิ่มงาน
        </b-button>
      </b-col>
    </b-row>
    <hr class="border-dashed-spacing my-2" />
    <template v-if="form.additional_work.length > 0" >
      <b-row class="px-4 py-3" v-for="(work, i) in form.additional_work" :key="i" >
        <b-col cols="6" class="bd-right">
          <b-form-group label="รายละเอียด">
            <b-form-input v-model="form.additional_work[i].detail" placeholder="ระบุรายละเอียดงาน"/>
          </b-form-group>
        </b-col>
        <b-col cols="5">
          <b-row class="d-flex align-items-center">
            <b-col :cols="isDetails ? '12' :'10'">
              <b-form-group label="ราคา">
                <b-input-group>
                  <b-form-input
                    placeholder="ระบุราคางาน"
                    v-model="form.additional_work[i].rate"
                    @input="$emit('calRate')"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="1" v-if="!isDetails">
              <b-button
                :disabled="form.additional_work.length < 2"
                variant="outline-danger"
                class="mt-2"
                @click="removeWork(i)"
              >
                <b-icon icon="trash-fill"></b-icon>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <b-row>
        <b-col lg="12" class="my-4 text-center">
          <h4 class="text-muted">ยังไม่มีงานเพิ่มเติมในขณะนี้</h4>
        </b-col>
      </b-row>
    </template>
  </div>
</template>
<script>
export default {
  components: {},
  props: { form: {} },
  data() {
    return {};
  },
  created() {},
  methods: {
    addWork() {
      this.form.additional_work.push({ detail: "", rate: "" });
    },
    removeWork(i) {
      this.form.additional_work.splice(i, 1);
    },
  },
  computed:{
    isDetails() {
      return !!this.$route.params.id;
    }
  },
  mounted() {},
};
</script>
